import { embedHeight } from './embed/embedHeight.js';
import { embedVoting } from './embed/embedVoting.js';
import { embedTicket } from './embed/embedTicket.js';

embedTicket();
embedHeight();
embedVoting();
